import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { alpha } from '@mui/material/styles';
import PaymentLinkSendPanel from './PaymentLinkSendPanel';
import { getBookingDrawerPanelSx, getBookingDrawerTheme } from '../../utils/bookingDrawerLayout';

/**
 * Full-screen overlay inside the payment drawer when "PAYMENT LINK" is selected (pre-booking).
 */
export default function PaymentLinkDrawerOverlay({
  open,
  onClose,
  bookingId,
  booking,
  amount,
  currency = 'INR',
  isDark,
  accent,
  onAfterSend,
  onSentSuccess,
  allowSend = true,
  sendBlockedMessage = '',
  canSendEmail = true,
  canSendWhatsApp = true,
}) {
  if (!open) return null;

  const drawerTheme = getBookingDrawerTheme(isDark);

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        bgcolor: alpha('#000', isDark ? 0.55 : 0.35),
        backdropFilter: 'blur(3px)',
      }}
    >
      <Paper
        elevation={12}
        sx={{
          position: 'relative',
          maxWidth: 440,
          width: '100%',
          p: 2.5,
          borderRadius: 2.5,
          ...getBookingDrawerPanelSx(isDark, {
            border: `1px solid ${isDark ? alpha(accent, 0.4) : alpha(accent, 0.25)}`,
          }),
        }}
      >
        <IconButton
          size="small"
          onClick={onClose}
          sx={{ position: 'absolute', top: 8, right: 8, color: isDark ? drawerTheme.subtleText : '#64748b' }}
          aria-label="Close"
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <Box sx={{ pr: 3.5, pt: 0.5 }}>
        <PaymentLinkSendPanel
          layout="overlay"
          bookingId={bookingId}
          booking={booking}
          amount={amount}
          currency={currency}
          isDark={isDark}
          accent={accent}
          allowSend={allowSend}
          sendBlockedMessage={sendBlockedMessage}
          canSendEmail={canSendEmail}
          canSendWhatsApp={canSendWhatsApp}
          onAfterSend={async () => {
            await onAfterSend?.();
            onClose();
          }}
          onSentSuccess={onSentSuccess}
        />
        </Box>
      </Paper>
    </Box>
  );
}
